import { openModal } from "@mantine/modals";
import QRCodeModal from "./QRCodeModal";

export const openQrCodeModal = (url: string, fileName?: string) =>
  openModal({
    withCloseButton: false,
    size: "auto",
    children: <QRCodeModal url={url} fileName={fileName} />,
  });
